import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { GoogleAuthProvider, signInWithCredential, signInWithPopup, User } from 'firebase/auth';
import { auth } from '../firebase';
import { Capacitor } from '@capacitor/core';

/**
 * Google OAuth 통합 함수.
 * - 네이티브(iOS/Android): skipNativeAuth=true → credential만 받아서
 *   웹 Firebase SDK에 직접 signInWithCredential
 * - 웹: 기존 signInWithPopup 유지
 */
export async function signInWithGoogle(): Promise<User> {
  if (Capacitor.isNativePlatform()) {
    console.log('[GoogleAuth] Step 1: Capacitor signInWithGoogle 호출');

    const result = await FirebaseAuthentication.signInWithGoogle();
    console.log('[GoogleAuth] Step 2: result 수신');

    const idToken = result.credential?.idToken;
    const accessToken = result.credential?.accessToken;
    console.log('[GoogleAuth] Step 3: idToken:', !!idToken, 'accessToken:', !!accessToken);

    if (!idToken) {
      throw new Error('Google 로그인에서 idToken을 받지 못했습니다.');
    }

    try {
      console.log('[GoogleAuth] Step 4: signInWithCredential 호출');
      const oauthCredential = GoogleAuthProvider.credential(idToken, accessToken || null);

      const signInPromise = signInWithCredential(auth, oauthCredential);
      const timeoutPromise = new Promise<never>((_, reject) =>
        setTimeout(() => reject(new Error('signInWithCredential 10초 타임아웃')), 10000)
      );

      const userCredential = await Promise.race([signInPromise, timeoutPromise]);
      console.log('[GoogleAuth] Step 5: Firebase user 획득', userCredential.user.email);

      return userCredential.user;
    } catch (signInError: any) {
      console.error('[GoogleAuth] signInWithCredential 실패:', signInError.code, signInError.message);
      throw signInError;
    }
  } else {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: 'select_account' });
    const result = await signInWithPopup(auth, provider);
    return result.user;
  }
}
